import { useState } from "react";
import ContactPhoneFields from "./ContactPhoneFields";
import formEmailMetadata from "../data/form-email-metadata.json";
import "./CareersForm.css";

const FORMSPREE_ENDPOINT = "https://formspree.io/f/mrgnqryj";
const EMAIL_METADATA = formEmailMetadata["/careers"];
const BAY_AREA_OPTION =
  "I am currently (or will soon be) located in the Bay Area. I am happy to come in to the office at least two days a week.Option 1";
const REMOTE_OPTION =
  "I don't live near Oakland, but I have a super compelling reason why you should consider me anyway.";

export default function CareersForm() {
  const [status, setStatus] = useState("idle");

  if (status === "success") {
    return (
      <div className="careers-form__success" role="status">
        <p>Thank you! We'll be in touch soon if you're a fit</p>
      </div>
    );
  }

  const submit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    setStatus("submitting");

    try {
      const response = await fetch(FORMSPREE_ENDPOINT, {
        body: new FormData(form),
        headers: { Accept: "application/json" },
        method: "POST",
      });
      if (!response.ok) throw new Error("Formspree rejected the form.");
      form.reset();
      setStatus("success");
    } catch {
      setStatus("error");
    }
  };

  return (
    <form
      action={FORMSPREE_ENDPOINT}
      className="careers-form"
      encType="multipart/form-data"
      method="POST"
      onSubmit={submit}
    >
      <input name="subject" type="hidden" value={EMAIL_METADATA.subject} />
      <input name="form_name" type="hidden" value={EMAIL_METADATA.formName} />

      <fieldset className="careers-form__name">
        <legend>Name</legend>
        <label>
          <span>
            First Name <small>(required)</small>
          </span>
          <input
            autoComplete="given-name"
            name="fname"
            required
            type="text"
          />
        </label>
        <label>
          <span>
            Last Name <small>(required)</small>
          </span>
          <input
            autoComplete="family-name"
            name="lname"
            required
            type="text"
          />
        </label>
      </fieldset>

      <label>
        <span>
          Email <small>(required)</small>
        </span>
        <input autoComplete="email" name="email" required type="email" />
      </label>

      <ContactPhoneFields />

      <fieldset className="careers-form__radios">
        <legend>
          Location <small>(required)</small>
        </legend>
        <label>
          <input name="location" required type="radio" value={BAY_AREA_OPTION} />
          <span>{BAY_AREA_OPTION}</span>
        </label>
        <label>
          <input name="location" required type="radio" value={REMOTE_OPTION} />
          <span>{REMOTE_OPTION}</span>
        </label>
      </fieldset>

      <label>
        <span>Role</span>
        <select defaultValue="" name="role">
          <option disabled hidden value="">
            Select an option
          </option>
          <option value="Lead Visualization Engineer">
            Lead Visualization Engineer
          </option>
          <option value="Lead Platform Engineer">Lead Platform Engineer</option>
          <option value="Something Else">Something Else</option>
        </select>
      </label>

      <label>
        <span>
          Why do you want to work with us? <small>(required)</small>
        </span>
        <textarea name="motivation" required rows="6" />
      </label>

      <label className="careers-form__file">
        <span>
          CV <small>(required)</small>
        </span>
        <input name="cv" required type="file" />
        <span className="careers-form__file-button">Add a File</span>
      </label>

      {status === "error" && (
        <p className="careers-form__error" role="alert">
          Unable to submit form. Please try again later.
        </p>
      )}

      <button
        className="button-link button-link--dark"
        disabled={status === "submitting"}
        type="submit"
      >
        {status === "submitting" ? "Submitting…" : "Submit"}
      </button>
    </form>
  );
}
